import styled from '@emotion/styled'
import { colors, font, spacing } from '@mobi/component-library/Theme/Common'

export const ContainerStyled = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: spacing.smx1,
  paddingTop: spacing.smx1,
})

export const PropositionContainerStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  flex: '1 0 0',
  alignItems: 'flex-start',
  fontFamily: font.family.primary,
})

export const PropositionDetailsStyled = styled.div<{ isDisabled: boolean }>(
  {
    fontSize: font.size.lg.fontSize,
    fontHeight: font.size.lg.lineHeight,
    fontWeight: font.weight.semibold,
  },
  ({ isDisabled }) => ({
    textDecoration: isDisabled ? 'line-through' : 'none',
    color: isDisabled ? colors.neutral[500] : colors.black,
  })
)

export const PropositionDisabledTypeStyled = styled.div({
  fontSize: font.size.lg.fontSize,
  fontHeight: font.size.lg.lineHeight,
  color: colors.neutral[500],
})

export const PropositionExtraRulesContainerStyled = styled.div({
  display: 'flex',
  gap: spacing.smx2,
  alignItems: 'center',
  color: colors.neutral[800],
})

export const PropositionExtraInfoStyled = styled.div({
  fontSize: font.size.md.fontSize,
  lineHeight: font.size.md.lineHeight,
  fontWeight: font.weight.regular,
})
